"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.facebookAdsLeadgenFormList = exports.facebookAdsLeadgenFormListResultSchema = exports.facebookAdsLeadgenFormListArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.facebookAdsLeadgenFormListArgsSchema = zod_1.z.object({
    limit: zod_1.z
        .number()
        .optional()
        .nullable()
        .describe('Maximum number of leadgen forms to return (default: 100)'),
    emitMode: zod_1.z.enum(['single', 'multi']).default('single').describe('Emit mode for results'),
});
exports.facebookAdsLeadgenFormListResultSchema = zod_1.z.object({
    forms: zod_1.z
        .array(zod_1.z.object({
        id: zod_1.z.string().describe('Leadgen form ID'),
        name: zod_1.z.string().describe('Leadgen form name'),
        status: zod_1.z.string().optional().describe('Form status (ACTIVE, PAUSED, ARCHIVED, DELETED)'),
        leadsCount: zod_1.z.number().optional().describe('Number of leads collected by this form'),
        createdTime: zod_1.z
            .string()
            .optional()
            .describe('When the form was created (ISO 8601 timestamp)'),
        locale: zod_1.z.string().optional().describe('Form locale (e.g., en_US)'),
        questions: zod_1.z
            .array(zod_1.z.object({
            type: zod_1.z.string().describe('Question type (EMAIL, FULL_NAME, CUSTOM, etc.)'),
            key: zod_1.z.string().optional().describe('Question key identifier'),
            label: zod_1.z.string().optional().describe('Question label (for custom questions)'),
            options: zod_1.z
                .array(zod_1.z.object({
                key: zod_1.z.string().describe('Option key'),
                value: zod_1.z.string().describe('Option display value'),
            }))
                .optional()
                .describe('Answer options for multiple choice questions'),
        }))
            .optional()
            .describe('Form questions'),
        privacyPolicyUrl: zod_1.z.string().optional().describe('Privacy policy URL'),
        contextCard: zod_1.z
            .object({
            title: zod_1.z.string().optional().describe('Context card title'),
            style: zod_1.z.string().optional().describe('Context card style'),
            content: zod_1.z.array(zod_1.z.string()).optional().describe('Context card content items'),
            button_text: zod_1.z.string().optional().describe('Context card button text'),
        })
            .optional()
            .describe('Form context card configuration'),
        thankYouPage: zod_1.z
            .object({
            title: zod_1.z.string().optional().describe('Thank you page title'),
            body: zod_1.z.string().optional().describe('Thank you page body text'),
            button_type: zod_1.z.string().optional().describe('Thank you page button type'),
            button_text: zod_1.z.string().optional().describe('Thank you page button text'),
            website_url: zod_1.z.string().optional().describe('Thank you page website URL'),
        })
            .optional()
            .describe('Thank you page configuration'),
        followUpActionUrl: zod_1.z.string().optional().describe('Follow-up action URL'),
        followUpActionText: zod_1.z.string().optional().describe('Follow-up action text'),
        questionPageCustomHeadline: zod_1.z
            .string()
            .optional()
            .describe('Custom headline for question page'),
        legalContent: zod_1.z
            .object({
            text: zod_1.z.string().optional().describe('Legal content text'),
            checkbox_text: zod_1.z.string().optional().describe('Legal content checkbox text'),
            link_text: zod_1.z.string().optional().describe('Legal content link text'),
            link_url: zod_1.z.string().optional().describe('Legal content link URL'),
        })
            .optional()
            .describe('Legal content configuration'),
    }))
        .describe('List of Facebook leadgen forms'),
    total_count: zod_1.z.number().describe('Total number of leadgen forms'),
});
exports.facebookAdsLeadgenFormList = (0, common_1.createToolMetadata)({
    id: 'facebookAdsLeadgenFormList',
    displayName: 'Facebook Leadgen Form List',
    displayDescription: 'List all Facebook leadgen forms for a Facebook page',
    category: 'ads',
    color: common_1.BRAND_COLORS.META,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.META),
    icon: 'meta',
    argsSchema: exports.facebookAdsLeadgenFormListArgsSchema,
}, exports.facebookAdsLeadgenFormListResultSchema);
